export default "__VITE_ASSET__1d00590c__"